<script setup>
import StatusBadge from '@/components/shared/core/StatusBadge.vue'
import LabelValue from '@/components/shared/transform/LabelValue.vue'
import {enrollmentStatuses, enrollmentStatusOptions} from '@/constants/enrollments.js'
import {componentColors} from '@/constants/components.js'
import {toRefs, computed} from 'vue'

//Emits and props
const props = defineProps({
  status: {
    type: String,
    required: true,
  },
})

//Determine color for status badge
const {status} = toRefs(props)
const color = computed(() => {
  switch (status.value) {
    case enrollmentStatuses.ACTIVE:
      return componentColors.SUCCESS

    case enrollmentStatuses.UP_NEXT:
    case enrollmentStatuses.SCHEDULED:
    case enrollmentStatuses.NOT_ENGAGED:
    case enrollmentStatuses.PAUSED:
      return componentColors.WARNING

    case enrollmentStatuses.ERROR:
    case enrollmentStatuses.WHATSAPP_WINDOW_VIOLATED:
      return componentColors.DANGER

    case enrollmentStatuses.COMPLETED:
      return componentColors.INFO

    case enrollmentStatuses.DISABLED:
    case enrollmentStatuses.OPTED_OUT:
    case enrollmentStatuses.CANCELED:
    default:
      return ''
  }
})
</script>

<template>
  <StatusBadge
    :color="color"
    v-bind="$attrs"
  >
    <span :class="$style.dot">•</span>
    <LabelValue
      :options="enrollmentStatusOptions"
      :value="status"
      show-unknown
    />
  </StatusBadge>
</template>

<style module lang="scss">
.dot {
  font-size: 1.5rem;
  line-height: 0.25rem;
  margin-right: -3px;
  margin-bottom: 2px;
  display: inline-block;
}
</style>
